module.exports = __webpack_public_path__ + "static/media/SA.7009ae78.png";